<template>
<div>
	<div @click="toggleBg" :class="{
		'mainItem': activeRouteName === 'TemplateEditor',
		'mainItemTemplateModalDark': activeRouteName !== 'TemplateEditor' && !isBgToggled,
		'mainItemTemplateModal': activeRouteName !== 'TemplateEditor' && isBgToggled,
		'mainItemTemplateModalNotLottie':  activeRouteName !== 'TemplateEditor' && template && template.content,
		}" :style="{  backgroundImage: baseBackground, backgroundSize: '100% 100%' }">
		<div v-if="fetchingLottie" class="is-loading-dark large absolute z-index-1 mt-10em text-black"></div>
		<div class="playlist-item asd text-center pointer" >
			<iframe
				class="frameContentTemplateModal min-w-100"
				scrolling="no"
				:class="{
					'frameContent image-track top-left': activeRouteName === 'TemplateEditor',
					'image-track-templatemodal': activeRouteName !== 'TemplateEditor',
					'frameContentTemplateModalTimer':  activeRouteName !== 'TemplateEditor' && template
					&& template.content && data && data.type === 'timer',
					'frameContentTemplateModalTicker':  activeRouteName !== 'TemplateEditor' && template
					&& template.content && data && data.type === 'ticker',
					'transform-4': activeRouteName !== 'TemplateEditor' && (data && data.type ? data.type === 'ticker' : ''),
					}"
				id="asd" frameborder="0" allow="accelerometer;" allowfullscreen>
			</iframe>
			<div :id="lottieId"
				scrolling="no"
				class="lottie-track top-left "
				:class="{'lottiepropsTemplateModal':  activeRouteName !== 'TemplateEditor'}"
				style="width: 100%;">
			</div>
		</div>
	</div>
</div>
</template>

<script>
export default {
	name: 'TemplatePreview',
	props: {
		data: {
			type: Object,
		},
		template: {
			type: Object,
		},
		lottieTemplate: {
			type: String,
		},
	},
	data: () => ({
		slug: '',
		baseBackground: null,
		fetchingLottie: false,
		isBgToggled: false,
	}),
	mounted() {
	},
	methods: {
		toggleBg() {
			this.isBgToggled = !this.isBgToggled;
		},
		hasProperty(obj, prop) {
			return Object.prototype.hasOwnProperty.call(obj, prop);
		},
		serializeCSS(css) {
			const src = css;
			const setupticker = src.replace(/__speed__/g, '40s');
			return setupticker;
		},
		async forcePlay() {
			const container = document.getElementById(this.lottieId);
			// eslint-disable-next-line no-undef
			lottie.destroy();
			this.fetchingLottie = true;
			if (this.lottieTemplate) {
				const url = this.lottieTemplate ? this.lottieTemplate : '';
				if (url) {
					const animationData = await (await fetch(this.lottieTemplate, { cache: 'no-cache' })).json();
					const animcomp = {
						name: 'lottiescene',
						container,
						renderer: 'svg',
						animationData,
						loop: true,
						prerender: true,
						autoplay: true,
						useframes: true,
					};
					// eslint-disable-next-line no-undef
					lottie.loadAnimation(animcomp);
					this.fetchingLottie = false;
					// eslint-disable-next-line no-undef
					lottie.play();
				}
			}
		},
	},
	computed: {
		lottieId() {
			return 'template-preview';
		},
		activeRouteName() {
			return this.$route.name;
		},
	},
	watch: {
		lottieTemplate() {
			if (this.lottieTemplate) {
				this.forcePlay();
			} else {
				// eslint-disable-next-line no-undef
				lottie.stop();
			}
		},
		template() {
			if (this.template) {
				let setupTemplate = '';
				const iframe = document.querySelector('.asd #asd');
				const js = this.template.script;
				const replaceDateTime = js.replace(/__DATETIME__/g, '"00:05:00"');
				const replaceFontFamily = replaceDateTime.replace(/__fontFamily__/g, '');
				const replaceFontSize = replaceFontFamily.replace(/__fontSize__/g, '');
				const replaceSubHeading = replaceFontSize.replace(/__subHeading__/g, '__subHeading__');
				const replaceReversed = replaceSubHeading.replace(/__REVERSE__/g, `parent.postMessage(JSON.stringify({type:'reversed', slug:'asd',
				layer_index: 'asd'}),'*')`);
				const replaceStart = replaceReversed.replace(/__START__/g, `parent.postMessage(JSON.stringify({type:'started', slug:'asd',
				layer_index: 'asd'}),'*')`);
				const replaceFinish = replaceStart.replace(/__FINISH__/g, `parent.postMessage(JSON.stringify({type:'started', slug:'asd',
				layer_index: 'asd'}),'*')`);
				const setupticker = replaceFinish.replace(/__TICKERTEXT__/g,
					JSON.stringify(['LOREM IPSUM DOLOR SIT AMET, CONSECTETUR ADIPISCING ELIT.',
						'NULLAM IN FELIS SODALES, ALIQUET JUSTO NEC, SOLLICITUDIN LACUS.',
						'NAM ET DIAM DIGNISSIM, EUISMOD URNA EGET, FACILISIS TURPIS.',
						'MAURIS SIT AMET NEQUE ET MAGNA ORNARE VEHICULA.']));
				const setupSpeed = setupticker.replace(/__SPEED__/g, 15);
				const setupBgColor = setupSpeed.replace(/__elementHeading__/g, '#00208a');
				const setupFontColor = setupBgColor.replace(/__FONTCOLOR__/g, '#FFFFFF');
				const setupGradient = setupFontColor.replace(/__ISGRADIENT__/g, true);
				const setupAngle = setupGradient.replace(/__ANGLE__/g, 0);
				const setupTitle = setupAngle.replace(/__TITLE__/g, 'NEWS');
				const setupHardGradient = setupTitle.replace(/__HARDGRADIENT__/g, false);
				const setupUseTimer = setupHardGradient.replace(/__USETIMER__/g, false);
				const setupBackgroundColor = setupUseTimer.replace(/__backgroundColor__/g, '#00208a');
				const setupColor = setupBackgroundColor.replace(/__color__/g, '#FFFFFF');
				const setupTimer = setupColor.replace(/__time__/g, '00:05:00');
				const setupMessage = setupTimer.replace(/__message__/g, 'message example');
				const playingStatus = setupMessage.replace(/__STATUS__/g, 'playing');
				const playingId = playingStatus.replace(/__APIURL__/g, process.env.VUE_APP_API_URL);
				const endpoint = playingId.replace(/__PLAYINGID__/g, '123');
				const showBackground = endpoint.replace(/__SHOWBG__/g, '100');
				const setupFontStyleIndex = showBackground.replace(/__FONTINDEX__/g, 0);
				const setupTimerFontStyleIndex = setupFontStyleIndex.replace(/__fontidx__/g, 0);

				const finalJs = `
				${setupTimerFontStyleIndex}
				function callback(event) {
					if (typeof event.data !== 'object') {
						const playlistItem = JSON.parse(event.data);
						if (playlistItem.mode === 'reverse' ) {
							reverseplayback();
						}
					}
				}
				if (window.addEventListener) {
					// For standards-compliant web browsers
					window.addEventListener("message", callback, false);
				}
				else {
					window.attachEvent("onmessage", callback);
				}`;
				const finalCss = this.serializeCSS(this.template.style);
				setupTemplate = `
						<html>
						<head>
						<script
								src="https://code.jquery.com/jquery-3.4.1.min.js"
								integrity="sha256-CSXorXvZcTkaix6Yvo6HppcZGetbYMGWSFlBw8HfCJo="
								crossorigin="anonymous">
						<\/script>
						<style>${finalCss}</style>
						</head>
						<body>
							${this.template.content}
							<script>${finalJs}<\/script>
						</body>
						</html>
					`;
				if (finalCss !== '' || this.template.content !== '' || setupFontStyleIndex !== '') {
					iframe.srcdoc = setupTemplate;
				} else {
					iframe.srcdoc = '';
				}
			} else {
				const iframe = document.querySelector('.asd #asd');
				iframe.srcdoc = '';
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.image-track {
	position: absolute;

	&.top-left {
		top: 4em;
	}
	&.top-right {
		top: 4em;
		right: 2em;
	}
	&.bottom-left {
		bottom: 5.5em;
		left: 0em;
	}
	&.bottom-right {
		bottom: 5.5em;
		right: 2em;
	}
	&.bottom-center {
		bottom: 50%;
		right: 50%;
	}
}
.lottie-track {
	position: absolute;
	top: 0;
}
.lottieprops {
	width:50%;
	height:50%;
}
.frameContent {
	width: 1200px;
	min-height: 300px;
	border: 0;
	-ms-transform-origin: 0 0;
	-moz-transform-origin: 0 0;
	-o-transform-origin: 0 0;
	-webkit-transform-origin: 0 0;
	transform-origin: 0 0;
}
body {
	margin: 0;
}

.mainItem {
	font-family: Open Sans;
	line-height: 1;
	position: absolute;
	width: 100%;
	height: 100%;
	overflow: hidden;
	background: #00FF00;
}

.mainItemTemplateModal {
	margin: auto;
	padding-top: 0;
	font-family: Open Sans;
	line-height: 1;
	position: absolute;
	width: 97.5%;
	height: 32%;
	overflow: hidden;
	background: black;
	background-image: url('/img/checkertransparent_light.png');
}

.mainItemTemplateModalDark {
	margin: auto;
	padding-top: 0;
	font-family: Open Sans;
	line-height: 1;
	position: absolute;
	width: 97.5%;
	height: 32%;
	overflow: hidden;
	background: black;
	background-image: url('/img/checkertransparent_dark.png');
}


.frameContentTemplateModalTimer {
	// margin-left: 4.5vh;
	position: absolute;
	right: 0;
	left: -13vh;
	top: 0;
	margin-top: 1em;
	transform: scale(0.4)!important;
	min-width: 2100px!important;
	height: 550px;
	-ms-transform-origin: 0 0;
	-moz-transform-origin: 0 0;
	-o-transform-origin: 0 0;
	-webkit-transform-origin: 0 0;
	transform-origin: 0 0;
}
.frameContentTemplateModalTicker {
	// margin-left: 4.5vh;
	position: absolute;
	right: 0;
	left: 0;
	top: 0;
	transform: scale(0.4615);
	min-width: 2100px!important;
	height: 550px;
	-ms-transform-origin: 0 0;
	-moz-transform-origin: 0 0;
	-o-transform-origin: 0 0;
	-webkit-transform-origin: 0 0;
	transform-origin: 0 0;
}

@media (max-width:1600px) and (min-width:1400px) {
	.frameContentTemplateModalTimer {
		margin-top: 3em;
		left: -10vh;
		transform: scale(0.3)!important;
	}
}

@media (max-width:1400px) and (min-width:1100px) {
	.frameContentTemplateModalTimer {
		margin-top: 4em;
		left: -8vh;
		transform: scale(0.25)!important;
	}
}

@media (max-width:1920px) and (min-width:1600px) {
	.frameContentTemplateModal {
		margin-left: 0vh;
	}
}

@media (max-width:1600px) and (min-width:1300px) {
	.frameContentTemplateModal {
		margin-left: 3vh;
	}
}

@media (min-width:1921px) {
	.frameContentTemplateModal {
		margin-left: 10%;
	}
}

@media (min-width:2200px) {
	.frameContentTemplateModal {
		margin-left: 20%;
		margin-top: 3em;
	}
}

@media (min-width:2600px) {
	.frameContentTemplateModal {
		margin-left: 30%;
		margin-top: 5em;
	}
}

@media (min-height:1108px) {
	.frameContentTemplateModalTicker {
		margin-top: 2em;
	}
}

@media (min-height:1199px) {
	.frameContentTemplateModalTicker {
		margin-top: 4em;
	}
}

@media (min-height:1299px) {
	.frameContentTemplateModalTicker {
		margin-top: 6.5em;
	}
}

.transform-4 {
	transform: scale(0.4615);
}

.image-track-templatemodal {
	position: absolute;
	&.top-left {
		top: 0;
	}
	&.top-right {
		top: 0;
		right: 2em;
	}
	&.bottom-left {
		bottom: 5.5em;
		left: 0em;
	}
	&.bottom-right {
		bottom: 5.5em;
		right: 2em;
	}
	&.bottom-center {
		bottom: 50%;
		right: 50%;
	}
}
.lottiepropsTemplateModal {
	width:100%;
	height:100%;
}
</style>
